export default {
    namespaced: true,

    state: {
        schedule: [
            {
            day: 'Sunday',
            details: [
              {
                mealType: 'Breakfast',
                timeForPrep: 30,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Lunch',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Dinner',
                timeForPrep: 45,
                planType: 'Self Planned',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
            ]
            },
            {
            day: 'Monday',
            details: [
              {
                mealType: 'Breakfast',
                timeForPrep: 30,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Lunch',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Dinner',
                timeForPrep: 45,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 20,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              }
            ]
            },
            {
            day: 'Tuesday',
            details: [
              {
                mealType: 'Breakfast',
                timeForPrep: 30,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Lunch',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Dinner',
                timeForPrep: 45,
                planType: 'Category',
                foodCategory: 'Mexican',
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 20,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              }
            ]
            },
            {
            day: 'Wednesday',
            details: [
              {
                mealType: 'Breakfast',
                timeForPrep: 30,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Lunch',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Dinner',
                timeForPrep: 45,
                planType: 'Category',
                foodCategory: 'Italian',
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 20,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              }
            ]
            },
            {
            day: 'Thursday',
            details: [
              {
                mealType: 'Breakfast',
                timeForPrep: 30,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Lunch',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Dinner',
                timeForPrep: 45,
                planType: 'Category',
                foodCategory: 'American',
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 20,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              }
            ]
            },
            {
            day: 'Friday',
            details: [
              {
                mealType: 'Breakfast',
                timeForPrep: 30,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Lunch',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Dinner',
                timeForPrep: 45,
                planType: 'Eat Out',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 20,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              }
            ]
            },
            {
            day: 'Saturday',
            details: [
              {
                mealType: 'Breakfast',
                timeForPrep: 30,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Lunch',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 5,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: false
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Dinner',
                timeForPrep: 45,
                planType: 'Category',
                foodCategory: 'American',
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              },
              {
                mealType: 'Snack',
                timeForPrep: 20,
                planType: 'Auto',
                foodCategory: null,
                individuals: [
                  {
                    name: 'Britton',
                    include: true
                  },
                  {
                    name: 'Alexia',
                    include: true
                  },
                  {
                    name: 'Lily',
                    include: true
                  }
                ],
                guests: [
                  {
                    name: 'Taryn',
                    include: false
                  }
                ]
              }
            ]
            },
        ],
    },

    actions: {
 
    },

    mutations: {


    },

    getters: {
        schedule(state) {
            return state.schedule
        }
    }

}
